import req from "../methods/req"
//获取当前用户菜单
export const getCurrentMenu = function (data) {
    return req({
        url: '/manage/auth.system/getCurrentMenu',
        ...data
    })
}

//获取当前用户信息
export const getCurrentUser = function (data) {
    return req({
        url: '/manage/auth.system/getCurrentUser',
        ...data
    })
}


//文件选择器
export const imageList = function (data) {
    return req({
        url: '/manage/common.upload/image',
        ...data,
    })
}

//上传图片
export const uploadFile = function (data) {
    return req({
        url: '/manage/common.upload/file',
        ...data,
        mode: 'upload'
    })
}

// oss
export const ossFile = function (data) {
    return req({
        url: '/manage/common.upload/ossFile',
        ...data
    })
}

// 上传图片base64图片
export const uploadBaseImage = function (data) {
    return req({
        url: '/manage/common.upload/uploadBaseImage',
        ...data
    })
}

// 可选分组
export const getGroupCate = function (data) {
    return req({
        url: '/manage/common.group/getGroupCate',
        ...data
    })
}

// 修改图片分组
export const editFile = function (data) {
    return req({
        url: '/manage/common.group/editFile',
        ...data
    })
}

// 新增
export const AddGroup = function (data) {
    return req({
        url: '/manage/common.group/add',
        ...data
    })
}

// 获取行业类目
export const getIndustry = function (data) {
    return req({
        url: '/manage/common.choice/getIndustry',
        ...data
    })
}

// 获取省市区三级联动
export const getCityFun = function (data) {
    return req({
        url: '/manage/common.choice/getCity',
        ...data
    })
}

// 获取可选业务员
export const getSalesman = function (data) {
    return req({
        url: '/manage/common.choice/getSalesman',
        ...data
    })
}

// 获取可选商家
export const getMerchantList = function (data) {
    return req({
        url: '/manage/common.choice/getMerchantList',
        ...data
    })
}

// 获取可选门店
export const getStoreList = function (data) {
    return req({
        url: '/manage/common.choice/getStoreList',
        ...data
    })
}

// 获取可选消费券
export const getCoupon = function (data) {
    return req({
        url: '/manage/setting.banner/getCoupon',
        ...data
    })
}

// 获取可选渠道
export const getChannelOption = function (data) {
    return req({
        url: '/manage/common.choice/getChannelList',
        ...data
    })
}
